// extracted by mini-css-extract-plugin
export default {"avatar":"doctorItem_avatar__iKyDV w-[80px] h-[80px] desktop_w-[121px] desktop_h-[121px]"};